const mockMap = new Map([
  [0, {
    content: {
      menu: {
        list: [
          { name: 'AAAA', action: 6, meta: { stdqa_id: '7983', type: '1' }, id: 1 },
          { name: 'BBB', action: 6, meta: { stdqa_id: '7982', type: '1' }, id: 2 },
          { action: 6, meta: { stdqa_id: '7982', type: '1' }, name: 'CCC', id: 3 },
          { action: 6, meta: { stdqa_id: '7978', type: '1' }, name: 'DDD', id: 4 },
        ],
        navType: 0,
        tit: '请选择您想咨询的内容',
      },
    },
  }],
  [1, {
    content: {
      menu: {
        list: [
          { id: 0, action: 5, name: '国内差旅费的费用开支标准' },
          { id: 1, action: 5, name: '校园网络上网费如何缴费' },
          { id: 2, action: 5, name: '账号密码忘记了怎么办' },
          { id: 3, action: 5, name: '注册开发者账号相关问题' },
        ],
        more_questions: 0,
        navType: 1,
        source: 1,
        tit: '请选择您想咨询的内容',
        length: 3,
        size: 3829,
      },
      id: 825,
      name: '高校微信导航',
    },
  }],
  [2, {
    content: {
      menu: {
        img: {
          index: 1,
          url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-c1ae523eae148d56442513bd77f5cbe8.png',
        },
        list: [
          { name: '国内差旅费的费用开支标准', meta: { stdqa_id: '8069', type: '1' }, action: 6, id: 1 },
          { name: '校园网络上网费如何缴费', action: 6, meta: { stdqa_id: '8051', type: '1' }, id: 2 },
          { name: '账号密码忘记了怎么办', action: 6, meta: { stdqa_id: '53', type: '2' }, id: 3 },
          { action: 6, meta: { stdqa_id: '5', type: '3' }, name: '注册开发者账号相关问题', id: 4 },
          {
            action: 7, id: 5,
            meta: { reception_id: 3007921066, reception_type: 0, name: '曹晓华(xiaohuacao)' }, name: '转人工客服',
          },
        ],
        more_questions: 0,
        navType: 2,
        source: 1,
        tit: '常见问题',
      },
    },
  }],
  [3, {
    content: {
      menu: {
        navType: 3,
        subs: [
          {
            list: [
              { id: 'b3q9c9ugun', action: 6, meta: { stdqa_id: '7272', type: '1' }, placeholder: '菜单1', name: '商品尺码推荐' },
              { id: 'pkr18tk2x9', action: 6, meta: { stdqa_id: '7271', type: '1' }, placeholder: '菜单2', name: '店铺热门活动' },
              { id: 'qaokan76jj', action: 6, meta: { stdqa_id: '7273', type: '1' }, placeholder: '菜单3', name: '订单发货时间' },
            ],
            more_questions: 0,
            source: 1,
            tit: '热门问题',
          },
          {
            list: [
              { id: 'jsuj1deq0a', action: 6, meta: { stdqa_id: '7260', type: '1' }, placeholder: '菜单1', name: '退换货须知' },
              { id: 'cfdvtnp7in', action: 6, meta: { stdqa_id: '7261', type: '1' }, placeholder: '菜单2', name: '退换货邮费问题' },
              { id: '4cdpcy81jy', action: 6, meta: { stdqa_id: '7263', type: '1' }, placeholder: '菜单3', name: '退货后多久到账' },
            ],
            more_questions: 0,
            source: 1,
            tit: '退换货',
          },
          {
            list: [
              { id: 'fvk2h196xr', action: 6, meta: { stdqa_id: '7270', type: '1' }, placeholder: '菜单1', name: '发票类型' },
              { id: 'cn8ryoyst3', action: 6, meta: { stdqa_id: '7267', type: '1' }, placeholder: '菜单2', name: '补开发票' },
              { id: 'jz49v996yy', action: 6, meta: { stdqa_id: '7269', type: '1' }, placeholder: '菜单3', name: '合开发票' },
            ],
            more_questions: 0,
            source: 1,
            tit: '商品发票',
          },
        ],
      },
    },
  }],
  [4, {
    content: {
      menu: {
        list: [
          {
            action: 6,
            icon: {
              index: 0,
              url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-65335b8b01c767c1d2edd1cbd92a64fa.svg',
            },
            id: 1,
            meta: { stdqa_id: '7983', type: '1' },
            name: '消息通知',
          },
          {
            action: 6,
            icon: {
              index: 1,
              url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-2ff52107ccb082b669e0725df88a15f8.svg',
            },
            id: 2,
            meta: { stdqa_id: '7984', type: '1' },
            name: '优惠卡券',
          },
          {
            action: 6,
            icon: {
              index: 2,
              url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-348165b5ea2c1a9ac323525ee51fd714.svg',
            },
            id: 3,
            meta: { stdqa_id: '7979', type: '1' },
            name: '精选推荐',
          },
          {
            action: 6,
            icon: {
              index: 2,
              url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-348165b5ea2c1a9ac323525ee51fd714.svg',
            },
            id: 4,
            meta: { stdqa_id: '7979', type: '1' },
            name: '精选推荐',
          },
          {
            action: 6,
            icon: {
              index: 2,
              url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-348165b5ea2c1a9ac323525ee51fd714.svg',
            },
            id: 5,
            meta: { stdqa_id: '7979', type: '1' },
            name: '精选推荐',
          },
        ],
        navType: 4,
        tit: '',
      },
      udfIcon: [
        {
          name: '消息通知',
          url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-65335b8b01c767c1d2edd1cbd92a64fa.svg',
        },
        {
          name: '优惠卡券',
          url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-2ff52107ccb082b669e0725df88a15f8.svg',
        },
        {
          name: '精选推荐',
          url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-348165b5ea2c1a9ac323525ee51fd714.svg',
        },
        {
          name: '签到打卡',
          url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-1da39adea8b2cbb2c91833e20bfb823a.svg',
        },
        {
          name: '售后保障',
          url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-8c69ca75868d4eabb31587c3e0c2445e.svg',
        },
        {
          name: '热度趋势',
          url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-8a9f45df504755f85d933d121634fbec.svg',
        },
        {
          name: '客服评价',
          url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-77a416fef3b3873c9627130a024ab941.svg',
        },
        {
          name: '商品购物',
          url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-94d2cac5b782234ed79026684bfbab1b.svg',
        },
      ],
    },
  }],
  [5, {
    content: {
      menu: {
        components: [
          {
            img: {
              index: 0,
              url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-2dc01f089874fc0e625a170e763a5e61.png',
            },
            list: [
              { name: '退费流程', action: 6, meta: { stdqa_id: '5416', type: '1' }, id: 1 },
              { name: '网校听课中心入口', action: 6, meta: { stdqa_id: '5413', type: '1' }, id: 2 },
              { name: '忘记用户名', action: 6, meta: { stdqa_id: '7239', type: '1' }, id: 3 },
            ],
            more_questions: 0,
            navType: 2,
            source: 1,
          },
          {
            list: [
              {
                action: 6,
                icon: { url: 'https://p.qpic.cn/qidian_pic/2852065243/202006254e691399e8693edd2382c288bb6adad3/0', index: 8 },
                id: 1,
                meta: { stdqa_id: '7239', type: '1' },
                name: '消息通知',
              },
              {
                action: 6,
                icon: { url: 'https://p.qpic.cn/qidian_pic/2852065243/2020042304e216cafd55d55448b60129053395ea/0', index: 9 },
                id: 2,
                meta: { stdqa_id: '7239', type: '1' },
                name: '优惠卡券',
              },
              {
                action: 6,
                icon: { url: 'https://p.qpic.cn/qidian_pic/2852065243/20190627ed675aa3caaaa1a89e3e2ebbf2acf665/0', index: 10 },
                id: 3,
                meta: { stdqa_id: '7244', type: '1' },
                name: '精选推荐',
              },
            ],
            navType: 4,
          },
        ],
        img: [],
        navType: 5,
        tit: '常见问题',
      },
      udfIcon: [
        {
          name: '消息通知',
          url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-65335b8b01c767c1d2edd1cbd92a64fa.svg',
        },
        {
          name: '优惠卡券',
          url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-2ff52107ccb082b669e0725df88a15f8.svg',
        },
        {
          name: '精选推荐',
          url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-348165b5ea2c1a9ac323525ee51fd714.svg',
        },
        {
          name: '签到打卡',
          url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-1da39adea8b2cbb2c91833e20bfb823a.svg',
        },
        {
          name: '售后保障',
          url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-8c69ca75868d4eabb31587c3e0c2445e.svg',
        },
        {
          name: '热度趋势',
          url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-8a9f45df504755f85d933d121634fbec.svg',
        },
        {
          name: '客服评价',
          url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-77a416fef3b3873c9627130a024ab941.svg',
        },
        {
          name: '商品购物',
          url: 'https://qidian-knowledge-1251316161.cos.ap-guangzhou.myqcloud.com/smartrobot-94d2cac5b782234ed79026684bfbab1b.svg',
        },
        {
          url: 'https://p.qpic.cn/qidian_pic/2852065243/202006254e691399e8693edd2382c288bb6adad3/0',
        },
        {
          url: 'https://p.qpic.cn/qidian_pic/2852065243/2020042304e216cafd55d55448b60129053395ea/0',
        },
        {
          url: 'https://p.qpic.cn/qidian_pic/2852065243/20190627ed675aa3caaaa1a89e3e2ebbf2acf665/0',
        },
      ],
    },
  }],
  [6, {
    content: {
      menu: {
        buttons: [
          {
            name: '转人工',
            id: 1,
            action: 7,
            meta: {
              id: 1,
              name: '国内旅游接待组',
              reception_id: 17671,
              reception_type: 1,
            },
          },
        ],
        desc: '123123123123123123123123123123123123123fsdfdsfsfsdfs',
        descError: false,
        list: [
          {
            action: 7,
            id: 1,
            meta: { reception_id: 20312, reception_type: 1, name: 'mfg01', id: 1 },
            name: '21445',
            sub: [],
          },
          {
            action: 4,
            id: 2,
            meta: [],
            name: '简单文本型简单文本型简单文本型简单文本型',
            sub: [
              { name: '简单文本型简单文本型简单文本型简单文本型', action: 6, meta: { stdqa_id: '8187', type: '1' }, id: 1 },
              { name: '4343', action: 6, meta: { stdqa_id: '8187', type: '1' }, id: 2 },
            ],
          },
        ],
        navType: 6,
        tit: '请选择你想咨询的内容',
        titleError: false,
      },
    },
  }],
]);
/**
 * @desc 机器人导航mock
 * @param {number} type - 类型  0，按钮型 1，简单文本型 2，基础型 3，多主题型 4，小卡片型 5，组合型 6，多级基础型
 */
export const getRobotNavContent = type => JSON.stringify(mockMap.get(type));

